import { Theme } from '@mui/material';
import { Components } from '@mui/material/styles';
import { getFocusRingStyle } from '@/src/components/focusring/focusring';

export const flowSwitch: Components<Theme>['MuiSwitch'] = {
  defaultProps: {
    disableRipple: true,
    disableFocusRipple: true,
    disableTouchRipple: true,
  },
  styleOverrides: {
    root: ({ theme }) => ({
      input: {
        maxWidth: 'none',
      },
      borderRadius: '1000px',
      '& .MuiSwitch-track': {
        borderRadius: '1000px',
      },
      '.Mui-disabled': {
        '.MuiSwitch-thumb': {
          backgroundColor: theme.palette.disabled.tertiary,
        },
      },
      position: 'relative',
      overflow: 'visible',
      ...getFocusRingStyle(theme, false, 0, ':has(.Mui-focusVisible)'),
    }),
    thumb: ({ theme }) => ({
      boxShadow: 'none',
      transition: '0.2s',
      color: theme.palette.onSurface.os0,
      borderRadius: '1000px',
      flexShrink: '0',
      maxWidth: 'none',
    }),
    track: ({ theme }) => ({
      boxSizing: 'border-box',
      opacity: '1',
      backgroundColor: theme.palette.onSurface.os500,
    }),
    switchBase: ({ theme }) => ({
      transition: '0.2s',
      '&.Mui-checked': {
        '& + .MuiSwitch-track': {
          opacity: '1',
          ...(theme.palette.mode === 'dark' && {
            background: theme.palette.brand.secondary,
          }),
        },
        ...(theme.palette.mode === 'dark' && {
          '& .MuiSwitch-thumb': {
            background: theme.palette.brand.tertiary,
          },
        }),
      },
      '&.Mui-disabled': {
        '& + .MuiSwitch-track': {
          backgroundColor: theme.palette.disabled.primary,
          opacity: '1',
        },
      },
    }),
    sizeMedium: {
      width: '52px',
      height: '24px',
      borderRadius: '1000px',
      padding: '0',
      '& .MuiSwitch-thumb': {
        width: '18px',
        height: '18px',
      },
      '& .MuiSwitch-switchBase': {
        width: '24px',
        padding: '3px',
        '&.Mui-checked': {
          transform: 'translateX(28px)',
        },
      },
      '&:active:not(.Mui-disabled)': {
        '.MuiSwitch-thumb': {
          width: '28px',
          transform: 'translateX(5px)',
        },
        '& .MuiSwitch-switchBase.Mui-checked .MuiSwitch-thumb': {
          transform: 'translateX(-5px)',
        },
      },
    },
    sizeSmall: {
      width: '34px',
      height: '16px',
      borderRadius: '1000px',
      padding: '0',
      '& .MuiSwitch-thumb': {
        width: '12px',
        height: '12px',
      },
      '& .MuiSwitch-switchBase': {
        width: '16px',
        padding: '2px',
        '&.Mui-checked': {
          transform: 'translateX(18px)',
        },
      },
      '&:active:not(.Mui-disabled)': {
        '& .MuiSwitch-thumb': {
          width: '18px',
          transform: 'translateX(3px)',
        },
        '& .MuiSwitch-switchBase.Mui-checked .MuiSwitch-thumb': {
          transform: 'translateX(-3px)',
        },
      },
    },
  },
};
